<template>
  <div>
    <b-alert v-if="statusMessage" :variant="statusVariant" show dismissible @dismissed="statusMessage = ''">
      {{ statusMessage }}
    </b-alert>

    <b-card>
      <b-card-title class="d-flex align-items-center mb-2">
        <feather-icon icon="GridIcon" size="24" class="mr-1" />
        Categorias da Minha Loja
      </b-card-title>
      <b-card-text class="text-muted mb-3">
        Selecione quais categorias aparecerão na sua loja e defina a ordem de exibição.
      </b-card-text>

      <div v-if="loading" class="text-center py-3">
        <b-spinner />
      </div>

      <div v-else>
        <b-table
          :items="categoriasComSelecao"
          :fields="campos"
          responsive
          show-empty
          empty-text="Nenhuma categoria disponível."
        >
          <template #cell(selecionada)="data">
            <b-form-checkbox
              :checked="data.item.selecionada"
              @change="toggleCategoria(data.item)"
              switch
            />
          </template>
          <template #cell(ordem)="data">
            <b-form-input
              v-if="data.item.selecionada"
              v-model.number="data.item.ordem"
              type="number"
              min="0"
              style="max-width: 80px;"
              size="sm"
            />
            <span v-else class="text-muted">—</span>
          </template>
        </b-table>

        <b-button variant="primary" @click="salvar" :disabled="saving" class="mt-2">
          <b-spinner v-if="saving" small class="mr-50" />
          Salvar Categorias
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BButton, BTable, BFormCheckbox,
  BFormInput, BSpinner, BAlert,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardTitle, BCardText, BButton, BTable, BFormCheckbox,
    BFormInput, BSpinner, BAlert,
  },
  data() {
    return {
      allCategorias: [],
      selectedCategorias: [],
      loading: true,
      saving: false,
      campos: [
        { key: 'selecionada', label: 'Ativa', sortable: false },
        { key: 'nome', label: 'Categoria', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: false },
        { key: 'ordem', label: 'Ordem', sortable: true },
      ],
      statusMessage: '',
      statusVariant: 'success',
    }
  },
  computed: {
    categoriasComSelecao() {
      return this.allCategorias.map(cat => {
        const selected = this.selectedCategorias.find(s => s.id_categoria_item === cat.id)
        return {
          ...cat,
          selecionada: !!selected,
          ordem: selected ? selected.ordem : 0,
          id_categoria_item: cat.id,
        }
      })
    },
  },
  async mounted() {
    await this.carregar()
  },
  methods: {
    async carregar() {
      this.loading = true
      try {
        const [all, selected] = await Promise.all([
          this.$store.dispatch('minhaLoja/fetchAllCategorias'),
          this.$store.dispatch('minhaLoja/fetchCategorias'),
        ])
        this.allCategorias = all
        this.selectedCategorias = selected.map(s => ({
          id_categoria_item: s.id_categoria_item,
          ordem: s.ordem,
        }))
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    toggleCategoria(item) {
      const idx = this.selectedCategorias.findIndex(s => s.id_categoria_item === item.id)
      if (idx >= 0) {
        this.selectedCategorias.splice(idx, 1)
      } else {
        this.selectedCategorias.push({ id_categoria_item: item.id, ordem: 0 })
      }
    },
    async salvar() {
      this.saving = true
      try {
        const categorias = this.categoriasComSelecao
          .filter(c => c.selecionada)
          .map(c => ({ id_categoria_item: c.id_categoria_item, ordem: c.ordem }))
        await this.$store.dispatch('minhaLoja/syncCategorias', categorias)
        this.statusMessage = 'Categorias salvas com sucesso!'
        this.statusVariant = 'success'
      } catch (e) {
        this.statusMessage = e.response?.data?.error || 'Erro ao salvar categorias.'
        this.statusVariant = 'danger'
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
